export function pageLoad() {
  this.$window.load(()=> {
    this.$body.addClass("loaded");
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/pageLoad.js